import Clipboard from 'clipboard';
import NavBar from '@/components/Nav.vue';
import Poster from '@/components/Poster.vue';

import client from '@/configs/client.js';

export default {
    name: 'InvitationPage',
    components: {
        NavBar,
        Poster,
    },
    data() {
        return {
            invitations: [],
            page: 1,
            more: true,
            loading: false,
            selected: 'success',
            posterBase64: '',
            entrance: true,
            shareShow: false,
            wechat: client.wechat,
            xinhua: client.xinhua,
            url: location.origin + (location.pathname.indexOf('xhdc') > -1 ? '/xhdc/' : '') + '?referrer=' + this.$store.state.user.uid
        }
    },
    created() {
        this.initShare({link: this.url});
        this.getDataList();
    },
    unmounted() {
        this.initShare();
    },
    methods: {
        share(type) {
            if (client.xinhua) {
                let data = {
                    imgbase64: this.posterBase64.substring(this.posterBase64.indexOf('base64,') + 7),
                    type: type
                };
                if (client.ios) {
                    window.webkit.messageHandlers.ShareImg.postMessage(data);
                } else {
                    /* eslint-disable */
                    xinhuanet.ShareImg(JSON.stringify(data));
                    /* eslint-enable */
                }
            } else {
                this.shareShow = true;
            }
        },
        download() {
            let data = {imgbase64: this.posterBase64.substring(this.posterBase64.indexOf('base64,') + 7)};
            if (client.ios) {
                window.webkit.messageHandlers.DownloadImg.postMessage(data);
            } else {
                /* eslint-disable */
                xinhuanet.DownloadImg(JSON.stringify(data));
                /* eslint-enable */
            }
        },
        copy() {
            let clipBoard = new Clipboard('#copy')
            clipBoard.on('success', () => {
                clipBoard.destroy()
                clipBoard = new Clipboard('#copy')
                this.$toast('复制成功')
            })
            clipBoard.on('error', () => {
                this.$toast('复制成功')
            })
        },
        posterReady(value) {
            this.posterBase64 = value;
        },
        getDataList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('invitation', {params: {type: this.selected, page: this.page}}).then(result => {
                    this.page++;
                    this.more = result.data.more;
                    this.invitations = this.invitations.concat(result.data.invitations);
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        changeTab(value) {
            this.selected = value;
            this.loading = false;
            this.page = 1;
            this.more = true;
            this.invitations = [];
            this.getDataList();
        },
        scroll(event) {
            if (event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight <= 100) {
                this.getDataList();
            }
        }
    }
}